module.exports = __webpack_public_path__ + "static/media/tools-area-zoom.4ed5cf2b.svg";